module.exports = __webpack_public_path__ + "static/media/sidebar-10.3811b091.jpg";